<script>

    import {createEventDispatcher} from "svelte";
    import Header from "../utils/Header.svelte";
    import Common from "../Common";
    import NewInvoiceData from "./invoice/NewInvoiceData.svelte";

    const dispatch = createEventDispatcher();

    export let rent;

    let currentMode = ''
    let step = 1;
    let newInvoiceData;
    let generationInProgress = false;

    function back() {
        dispatch('back', {});
    }

    function downloadInvoice(mode) {
        currentMode = mode;
        if (!rent.paid) {
            Common.error('Aby wygenerować fakturę należy ją najpierw opłacić');
            return;
        }

        if (rent.invoiceId) {
            getInvoice()
        } else {
            if (rent.addresses.length === 0) {
                step = 3;
                setTimeout(() => {
                    newInvoiceData.initialize();
                }, 100);
            } else {
                step = 2;
            }
        }
    }

    function addInvoiceData() {
        step = 3;
        setTimeout(() => {
            newInvoiceData.initialize();
        }, 300);
    }

    function newAddressCreated() {
        step = 2;
        Common.getRent(rent.uuid).then(function (response) {
            rent = response;
        });
    }

    function getInvoice() {
        if (currentMode === 'device') {
            window.open(Common.BASE_API + '/order/myrent/donwloadinvoice/' + rent.uuid, '_self');
        } else {
            //TODO:
        }
        step = 1;
    }

    function generateInvoice(address) {
        // if (currentMode === 'mail' && Common.isEmpty(address.mail)) {
        //     Common.error("Nie można wysłać faktury bo podane dane nie mają adresu e-mail");
        //     return;
        // }
        generationInProgress = true;
        Common.generateMyRentInvoice(rent.uuid, address.uuid).then(function (response) {
            generationInProgress = false;
            getInvoice();
        });
    }
</script>

<main class="flex flex-col w-full flex-wrap drogowskazFont min-h-full">

    <Header on:back={back}></Header>

    {#if step === 1}
        <div class="flex flex-row w-full bg-blue-2 white text-white  text-base text-center justify-center py-12 px-4"
             on:click={() => downloadInvoice('device')}>
            <div class="w-1/4 text-center flex flex-col justify-center items-center">
                <i class="fa fa-download fa-3x blue-3"></i>
            </div>
            <div class="w-3/4 text-center justify-center flex flex-col">
            <span class="text-3xl mt-4">
                <span>Pobierz fakturę</span>
            </span>
            </div>
        </div>
        <!--        <div class="flex flex-row w-full bg-blue-3 white text-white  text-base text-center justify-center py-12 px-4"-->
        <!--             on:click={() => downloadInvoice('mail')}>-->
        <!--            <div class="w-1/4 text-center flex flex-col justify-center items-center">-->
        <!--                <i class="fa fa-envelope fa-3x blue-2"></i>-->
        <!--            </div>-->
        <!--            <div class="w-3/4 text-center justify-center flex flex-col">-->
        <!--            <span class="text-3xl mt-4">-->
        <!--                <span>-->
        <!--                    Wyślij fakturę mailem</span>-->
        <!--            </span>-->
        <!--            </div>-->
        <!--        </div>-->
    {:else if step === 2}
        <div class="flex flex-row w-full bg-blue-3 white text-white  text-base text-center justify-center py-12 px-4">
            <div class="w-1/4 text-center flex flex-col justify-center items-center">
                <i class="fa fa-plus fa-3x blue-2"></i>
            </div>
            <div class="w-3/4 text-center justify-center flex flex-col" on:click={addInvoiceData}>
                <span class="text-2xl mt-4">
                    <span>Podaj nowe dane do faktury</span>
                </span>
            </div>
        </div>

        {#each rent.addresses as adr, i}
            <div class="flex flex-row w-full  white text-white  text-base text-center justify-center py-8 px-4 border-blue-900"
                 class:hidden={generationInProgress}
                 on:click={() => generateInvoice(adr)}
                 class:bg-blue-2="{i%2 === 0}"
                 class:border-b="{i%2 === 0}"
                 class:bg-blue-3="{i%2 === 1}">
                <div class="w-1/4 text-center flex flex-col justify-center items-center">
                    <i class="fa fa-check fa-3x "
                       class:blue-2="{i%2 === 1}"
                       class:blue-3="{i%2 === 0}"></i>
                </div>
                <div class="w-3/4 text-center justify-center flex flex-col text-2xl">
                    <div class="text-underline mb-4">Użyj poniższych danych:</div>
                    <div class="flex flex-row justify-center flex-wrap">
                        <span class:hidden={!adr.name}>{adr.name}</span>
                        <span class:hidden={!adr.nip}>NIP: {adr.nip}</span>
                    </div>
                    {#if adr.address || adr.postalCode || adr.city}
                        <div class="flex flex-row justify-center flex-wrap">
                            <span class:hidden={!adr.address}>{adr.address}</span>
                            <span class:hidden={!adr.postalCode}>{adr.postalCode}</span>
                            <span class:hidden={!adr.city}>{adr.city}</span>
                        </div>
                    {/if}
                    {#if adr.phone || adr.mail}
                        <div class="flex flex-row justify-center flex-wrap">
                            <span class:hidden={!adr.phone}>{adr.phone}</span>
                            <span class:hidden={!adr.mail}>{adr.mail}</span>
                        </div>
                    {/if}
                </div>
            </div>
        {/each}

    {:else if step === 3}
        <NewInvoiceData bind:this={newInvoiceData} rent={rent} on:save={newAddressCreated}></NewInvoiceData>
    {/if}


</main>
